import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { GenericErrorDisplay } from "../../../common/displays";
import { useRoutes } from "../../../common/hooks";
import {
    FASTSHIFT_PATH_KEYS,
    FASTSHIFT_PATHS
} from "../../../common/routes/constants";
import { useFastshiftSelector } from "../../../state";
import { FastshiftUserDetailsExpectedError } from "../../../state/types";

import { useFastshiftPageAnalytics } from "./hooks";
import { NotEligibleDisplay } from "./not-eligible-display";

export const FastshiftPage = () => {
    const { paths, getPathByDomainId } = useRoutes();

    useFastshiftPageAnalytics();

    const { data: userDetails, error: userDetailsError } = useFastshiftSelector(
        (state) => state.userDetails
    );
    const navigate = useNavigate();
    const isPartnerOrInternal =
        userDetails?.userType === "PARTNER" ||
        userDetails?.userType === "INTERNAL";

    useEffect(() => {
        if (userDetails) {
            if (userDetails.userType === "CUSTOMER") {
                const url = getPathByDomainId(
                    FASTSHIFT_PATHS[FASTSHIFT_PATH_KEYS.OVERVIEW],
                    userDetails.userDomain?.domainId ?? ""
                );
                if (url) {
                    navigate(url);
                }
            } else if (isPartnerOrInternal) {
                const url = paths.selection;
                if (url) {
                    navigate(url);
                }
            }
        }
    }, [
        userDetails,
        isPartnerOrInternal,
        navigate,
        getPathByDomainId,
        paths.selection
    ]);

    if (
        userDetailsError ===
        FastshiftUserDetailsExpectedError.NO_ELIGIBLE_LICENSE
    ) {
        return (
            <div>
                <NotEligibleDisplay ineligibilityReason="no-license" />
            </div>
        );
    }

    if (userDetailsError === FastshiftUserDetailsExpectedError.NO_ACCESS) {
        return (
            <div>
                <NotEligibleDisplay ineligibilityReason="not-linked" />
            </div>
        );
    }

    return (
        <div>
            <GenericErrorDisplay />
        </div>
    );
};
